import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface StartImpersonationPayload {
  targetTenantId: number;
  targetUserId: number;
  reason: string;
  durationMinutes: number;
}

const start = (payload: StartImpersonationPayload) => http.post(API_ENDPOINTS.impersonationStart, payload);

const end = (impersonationToken: string) =>
  http.post(
    API_ENDPOINTS.impersonationEnd,
    {},
    { headers: { 'X-Impersonation-Token': impersonationToken } }
  );

const ImpersonationService = { start, end };

export default ImpersonationService;
